<template>
    <svg version="1.2" xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink"
         overflow="visible"
         preserveAspectRatio="none"
         viewBox="0 0 24 24"
         width="24"
         height="24">
        <g>
            <path xmlns:default="http://www.w3.org/2000/svg" d="M7 10l5 5 5-5z" style="fill: rgb(18, 18, 18);" vector-effect="non-scaling-stroke"/>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "ArrowDownSVG"
    }
</script>

<style scoped>

</style>